module.exports = __webpack_public_path__ + "assets/img/bg7.53f11157.jpg";